import { makeHttpRequest } from "@/shared";

/**
 * USE-2742: получает статусы интеграций отдельным lazy-вызовом.
 * Раньше integrations возвращались в /workspace/init и блокировали загрузку
 * кабинета на 3-4 секунды (9 HTTP-запросов к внешним сервисам Atol/Zadarma/
 * FDoc/Amo/...). Теперь init возвращается за ~500ms, integrations подгружаются
 * в фоне и не задерживают рендер UI.
 */
export const getWorkspaceIntegrations = async function () {
    const { data } = await makeHttpRequest({
        url: "/workspace/integrations",
        method: "GET",
        // Сводку статусов кабинет запрашивает сам, фоном, у каждого входящего.
        // У сотрудника без раздела «Интеграции» ответ — отказ, и это штатно:
        // показывать всплывашку на каждом входе не за что
        silentRefusal: true,
    });

    return data.data?.integrations ?? data.integrations ?? null;
};
